import { render, staticRenderFns } from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=template&id=6bfacd22"
import script from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgeCardAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports